module.exports = __webpack_public_path__ + "img/szzs.091370c4.png";